import '../../common-init';

import angular from 'angular';

// Libraries
// import 'angular-translate';
import 'angular-bootstrap';

// Constants
import constants from '../../../lib/constants';

// Component
import responseComponent from './response.component';

// Load all services
import '../../../lib/service';
import logServiceModule from '../../../lib/service/LogService';

// Components
import '../../../lib/components/recapResponsePage';
import errorList from '../../../lib/components/errorList/index';
import messageList from '../../../lib/components/messageList/index';
import eventInfo from '../../../lib/components/eventInfo';
import recapResponseNavigation from './components/recapResponseNavigation';
import languageSelector from '../../../lib/components/languageSelector';
import appVersionLabel from '../../../lib/components/appVersionLabel';
import siteVersionLabel from '../../../lib/components/siteVersionLabel';

// Translations
import translations from '../../../lib/translation';

import geolocation from 'angularjs-geolocation';


const moduleName = 'recaps.response';
let module = angular.module(moduleName, [
  constants,
  translations,
  'ui.bootstrap',
  'geolocation',
  'recaps.components.recapResponsePage',
  errorList.name,
  messageList.name,
  eventInfo.name,
  logServiceModule.name,
  recapResponseNavigation.name,
  languageSelector.name,
  appVersionLabel.name,
  siteVersionLabel.name,
]);

module.component('recapResponse', responseComponent);

module.filter('ucfirst', function() {
  return function(input) {
    return input.charAt(0).toUpperCase() + input.slice(1);
  };
});

// module.config ($animateProvider =>{
//   //$animateProvider.classNameFilter(/\banimate\b/);
//   //$animateProvider.classNameFilter(/^(?:(?!no-animate).)*$/);

// }); 


export default module;
